module.exports = __webpack_public_path__ + "static/015-77288181adbb6e95854e2bc6baea75ce.jpg";